import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Fieldset } from 'primereact/fieldset'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DateTime } from 'luxon'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import BadgeStatusCte from '../../../../components/BadgeStatusCte/BadgeStatusCte'
import {
  MENSAGEM_NFSE_ENVIADA,
  NFSE_STATUS,
  NFSE_STATUS_OPTIONS,
} from '../../../../constants/fiscal'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalEmitirNfse from '../EmitirNfse/ModalEmitirNfse'
import { formatarMoeda } from '../EmitirNfse/emitirNfse.util'
import useGestaoNfse, { LOAD_MESSAGE } from './GestaoNfseHook'
import ModalCancelarNfse from './ModalCancelarNfse'
import ModalReenviarEmailNfse from './ModalReenviarEmailNfse'

function formatarDataHora(valor) {
  return valor ? DateTime.fromISO(valor).toFormat('dd/MM/yyyy HH:mm') : ''
}

function formatarData(valor) {
  return valor ? DateTime.fromISO(valor).toFormat('dd/MM/yyyy') : ''
}

const quebraPalavra = { wordBreak: 'break-word' }

function itensDoMenu(nfse) {
  const itens = []
  if (nfse.url_danfse) itens.push('DANFSe')
  if (nfse.caminho_xml) itens.push('XML')
  if (nfse.caminho_xml_cancelamento) itens.push('XML Cancelamento')
  if (nfse.url) itens.push('Consultar no portal')
  if ([NFSE_STATUS.PROCESSANDO, NFSE_STATUS.AUTORIZADO].includes(nfse.status))
    itens.push('Sincronizar Status')
  if ([NFSE_STATUS.AUTORIZADO, NFSE_STATUS.CANCELADO].includes(nfse.status))
    itens.push('Reenviar E-mail')
  if (nfse.status === NFSE_STATUS.AUTORIZADO) itens.push('Cancelar NFS-e')
  if (nfse.status === NFSE_STATUS.ERRO_AUTORIZACAO) itens.push('Ver Erros')
  if ([NFSE_STATUS.ERRO_AUTORIZACAO, NFSE_STATUS.CANCELADO].includes(nfse.status))
    itens.push('Duplicar')
  return itens
}

function GestaoNfse({ dispatch, selectedTp, history }) {
  const { state, localDispatch } = useGestaoNfse()
  const [globalFilter, setGlobalFilter] = useState('')

  const emissores = Array.from(
    new Map(
      state.nfses.map(nfse => [
        nfse.emissor_id,
        { label: nfse.emissor_razao_social, value: nfse.emissor_id },
      ]),
    ).values(),
  )

  // Events
  useEffect(() => {
    localDispatch.onPesquisar(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTp])

  useEffect(() => {
    if (state.loadingMessage === LOAD_MESSAGE.NONE) dispatch(hideLoadingBox())
    else dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
  }, [state.loadingMessage, dispatch])

  useEffect(() => {
    if (state.errorMessage || state.successMessage) {
      dispatch(showMessageBox(state.successMessage, state.errorMessage))
      localDispatch.resetMessages()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errorMessage, state.successMessage])

  const onNfseEmitida = nfse => {
    localDispatch.onEmitirClose()
    dispatch(showMessageBox(nfse.aviso ? null : MENSAGEM_NFSE_ENVIADA, nfse.aviso || null))
    localDispatch.recarregar(selectedTp)
  }

  // Render
  return (
    <>
      <PageHeader>11.1 - Gestão de NFS-e</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          btnLabel="Emitir NFS-e"
          onNovo={() => localDispatch.onEmitirClick(selectedTp)}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-3">
              <Periodo
                periodoFinal={state.periodo.dataFinal}
                periodoInicial={state.periodo.dataInicial}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onPesquisar(selectedTp, pInicial, pFinal)
                }
              />
            </div>
            <div style={{ display: 'flex', marginLeft: '5px', gap: '10px', paddingTop: 35 }}>
              <div>
                <Btn
                  onClick={() =>
                    localDispatch.onDownload(
                      selectedTp,
                      state.filtradas.filter(nfse => nfse.selected),
                    )
                  }
                >
                  Download NFS-e
                </Btn>
              </div>
              <div>
                <a href="https://status.focusnfe.com.br/" target="_blank" rel="noopener noreferrer">
                  <Btn>Consultar Status Emissão NFS-e</Btn>
                </a>
              </div>
            </div>

            <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12 p-mt-2">
              <div className="p-grid">
                <div className="p-col-6 p-md-4">
                  <CustomMultiSelect
                    label="Status"
                    value={state.filtroStatus}
                    options={NFSE_STATUS_OPTIONS}
                    onChange={value => localDispatch.onFiltroChange('filtroStatus', value)}
                    optionLabel="label"
                  />
                </div>
                <div className="p-col-6 p-md-4">
                  <CustomMultiSelect
                    label="Emissor"
                    value={state.filtroEmissores}
                    options={emissores}
                    onChange={value => localDispatch.onFiltroChange('filtroEmissores', value)}
                    optionLabel="label"
                  />
                </div>
              </div>
            </Fieldset>

            <div className="p-col-12" style={{ marginTop: 15, marginBottom: 10 }}>
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={value => localDispatch.onSelecionarTodosChange(value)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>

            <div className="p-col-12">
              <DataTable
                value={state.filtradas}
                paginator={true}
                rows={10}
                emptyMessage="Nenhuma NFS-e no período"
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
              >
                <Column
                  header={'#'}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={() => localDispatch.onItemClicked(item)}
                    />
                  )}
                  style={tableCellCentered(50)}
                />
                <Column field="numero" header="Número" style={tableCellCentered(75)} />
                <Column
                  field="data_emissao"
                  header="Emissão"
                  style={tableCellCentered(115)}
                  body={item => formatarDataHora(item.data_emissao)}
                />
                <Column
                  field="data_competencia"
                  header="Competência"
                  style={tableCellCentered(105)}
                  body={item => formatarData(item.data_competencia)}
                />
                <Column field="tomador_razao_social" header="Tomador" style={quebraPalavra} />
                <Column
                  field="tomador_cnpj_cpf"
                  header="CNPJ/CPF"
                  style={{ ...tableCellCentered(160), whiteSpace: 'nowrap' }}
                  body={item => <Cnpj>{item.tomador_cnpj_cpf}</Cnpj>}
                />
                <Column
                  field="servico_descricao"
                  header="Serviço"
                  style={{ ...tableCellCentered(130), ...quebraPalavra }}
                />
                <Column
                  field="notas"
                  header="Notas"
                  style={tableCellCentered(110)}
                  body={item =>
                    item.notas ? (
                      <span title={item.notas}>
                        {item.notas.split(', ').length > 3
                          ? `${item.notas.split(', ').length} notas`
                          : item.notas}
                      </span>
                    ) : null
                  }
                />
                <Column
                  field="valor_servico"
                  header="Valor"
                  style={tableCellCentered(100)}
                  body={item => formatarMoeda(item.valor_servico)}
                />
                <Column field="emissor_razao_social" header="Emissor" style={quebraPalavra} />
                <Column
                  field="status"
                  header="Status"
                  style={tableCellCentered(130)}
                  body={item => (
                    <span
                      title={
                        item.status === NFSE_STATUS.ERRO_AUTORIZACAO && item.mensagem
                          ? item.mensagem
                          : undefined
                      }
                    >
                      <BadgeStatusCte status={item.status} />
                    </span>
                  )}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(60)}
                  body={nfse => {
                    const itens = itensDoMenu(nfse)
                    return itens.length ? (
                      <ThreeDots
                        items={itens}
                        onClick={item => localDispatch.onMenuItemClick(item, nfse, selectedTp)}
                      />
                    ) : null
                  }}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalCancelarNfse
        isVisible={state.modalCancelar.visible}
        nfse={state.modalCancelar.nfse}
        onCancel={localDispatch.onCancelarClose}
        onSave={(nfse, justificativa) =>
          localDispatch.onCancelarSave(selectedTp, nfse, justificativa)
        }
        onError={localDispatch.onModalError}
      />
      <ModalReenviarEmailNfse
        isVisible={state.modalEmail.visible}
        nfse={state.modalEmail.nfse}
        onCancel={localDispatch.onEmailClose}
        onSave={(nfse, emails) => localDispatch.onEmailSave(selectedTp, nfse, emails)}
        onError={localDispatch.onModalError}
      />
      <ModalEmitirNfse
        visible={state.modalEmitir.visible}
        tpId={selectedTp}
        contexto={state.modalEmitir.contexto}
        onClose={localDispatch.onEmitirClose}
        onEmitida={onNfseEmitida}
        onError={localDispatch.onModalError}
      />
    </>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(GestaoNfse))
